// if (!window.Eurus.loadedScript.includes('sticky-atc.js')) {
//   window.Eurus.loadedScript.push('sticky-atc.js');

//   requestAnimationFrame(() => {
//     document.addEventListener('alpine:init', () => {
//       Alpine.data('xStickyATC', (sectionId, is_combined) => ({
//         openDetailOnMobile: false,
//         currentAvailableOptions: [],
//         options: [],
//         init() {
//           if (!is_combined) {
//             this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
//           }

//           document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
//             if (is_combined) {
//               this.renderVariant(e.detail.html);
//             } else {
//               this.currentAvailableOptions = e.detail.currentAvailableOptions,
//               this.options = e.detail.options;
//             }

//             this.renderProductPrice(e.detail.html);
//             this.renderMedia(e.detail.html);
//           });
//         },
//         renderProductPrice(html) {
//           const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
//           destinations.forEach((destination) => {
//             const source = html.getElementById('price-sticky-' + sectionId);
//             if (source && destination) destination.innerHTML = source.innerHTML;
//           })
//         },
//         renderMedia(html) {
//           const destination = document.getElementById('product-image-sticky-' + sectionId);
//           const source = html.getElementById('product-image-sticky-' + sectionId);
  
//           if (source && destination) destination.innerHTML = source.innerHTML;
//         },
//         renderVariant(html) {
//           const destination = document.getElementById('variant-update-sticky-' + sectionId);
//           const source = html.getElementById('variant-update-sticky-' + sectionId);
  
//           if (source && destination) destination.innerHTML = source.innerHTML;
//         },
//         changeOptionSticky(event) {
//           Array.from(event.target.options)
//             .find((option) => option.getAttribute('selected'))
//             .removeAttribute('selected');
//           event.target.selectedOptions[0].setAttribute('selected', 'selected');
//           const input = event.target.selectedOptions[0];
//           const inputId = input.id;
//           const targetUrl = input.dataset.productUrl;
//           const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
//           document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
//             detail: {
//               inputId: inputId,
//               targetUrl: targetUrl,
//               variantElSticky: variantEl
//             }
//           }));
//         }
//       }))
//     })
//   })
// }

// v2
// if (!window.Eurus.loadedScript.includes('sticky-atc.js')) {
//   window.Eurus.loadedScript.push('sticky-atc.js');

//   requestAnimationFrame(() => {
//     document.addEventListener('alpine:init', () => {
//       Alpine.data('xStickyATC', (sectionId, is_combined) => ({
//         openDetailOnMobile: false,
//         currentAvailableOptions: [],
//         options: [],
//         init() {
//           if (!is_combined) {
//             this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
//           }

//           document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
//             if (is_combined) {
//               this.renderVariant(e.detail.html);
//             } else {
//               this.currentAvailableOptions = e.detail.currentAvailableOptions,
//               this.options = e.detail.options;
//             }

//             this.renderProductPrice(e.detail.html);
//             this.renderMedia(e.detail.html);
//           });
//         },
        
//         renderProductPrice(html) {
//           const source = html.getElementById('price-sticky-' + sectionId);
//           if (!source) return;
          
//           const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          
//           destinations.forEach((destination) => {
//             // 只更新特定的价格元素，保护自定义结构
//             this.updatePriceElement(source, destination, '.price-sale');
//             this.updatePriceElement(source, destination, '.cap s');
//             this.updatePriceElement(source, destination, '.show_save_container');
//             this.updatePriceElement(source, destination, '.hidden'); // 隐藏的价格值
            
//             // 同步其他可能需要更新的价格相关元素
//             this.updatePriceElement(source, destination, '.product_card_price');
//             this.updatePriceElement(source, destination, '.cap_custom');
            
//             // 保留你的自定义结构不变
//           });
//         },
        
//         updatePriceElement(source, destination, selector) {
//           const sourceElement = source.querySelector(selector);
//           const destElement = destination.querySelector(selector);
          
//           if (sourceElement && destElement) {
//             // 只同步文本内容和必要的属性
//             destElement.textContent = sourceElement.textContent;
            
//             // 同步重要属性
//             const attributesToSync = ['data-price', 'data-variant', 'aria-label', 'class', 'style'];
//             attributesToSync.forEach(attr => {
//               if (sourceElement.hasAttribute(attr)) {
//                 destElement.setAttribute(attr, sourceElement.getAttribute(attr));
//               }
//             });
            
//             // 特殊处理：对于隐藏的价格值，确保数据属性同步
//             if (selector === '.hidden' && sourceElement.textContent) {
//               destElement.textContent = sourceElement.textContent;
//             }
//           }
//         },
        
//         renderMedia(html) {
//           const destination = document.getElementById('product-image-sticky-' + sectionId);
//           const source = html.getElementById('product-image-sticky-' + sectionId);
  
//           if (source && destination) destination.innerHTML = source.innerHTML;
//         },
        
//         renderVariant(html) {
//           const destination = document.getElementById('variant-update-sticky-' + sectionId);
//           const source = html.getElementById('variant-update-sticky-' + sectionId);
  
//           if (source && destination) destination.innerHTML = source.innerHTML;
//         },
        
//         changeOptionSticky(event) {
//           Array.from(event.target.options)
//             .find((option) => option.getAttribute('selected'))
//             .removeAttribute('selected');
//           event.target.selectedOptions[0].setAttribute('selected', 'selected');
//           const input = event.target.selectedOptions[0];
//           const inputId = input.id;
//           const targetUrl = input.dataset.productUrl;
//           const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
//           document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
//             detail: {
//               inputId: inputId,
//               targetUrl: targetUrl,
//               variantElSticky: variantEl
//             }
//           }));
//         }
//       }))
//     })
//   })
// }

// v3

if (!window.Eurus.loadedScript.includes('sticky-atc.js')) {
  window.Eurus.loadedScript.push('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          if (!is_combined) {
            this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
          }

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            if (is_combined) {
              this.renderVariant(e.detail.html);
            } else {
              this.currentAvailableOptions = e.detail.currentAvailableOptions,
              this.options = e.detail.options;
            }

            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });
          
        },
        
        renderProductPrice(html) {
          const source = html.getElementById('price-sticky-' + sectionId);
          if (!source) return;
          
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          
          destinations.forEach((destination) => {
            // 保存原始价格信息用于计算
            const originalSalePrice = destination.querySelector('.price-sale').textContent;
            const originalComparePrice = destination.querySelector('.cap s').textContent;
            
            // 更新价格元素
            this.updatePriceElement(source, destination, '.price-sale');
            this.updatePriceElement(source, destination, '.cap s');
            this.updatePriceElement(source, destination, '.hidden');
            this.updatePriceElement(source, destination, '.product_card_price');
            this.updatePriceElement(source, destination, '.cap_custom');
            
            // 获取更新后的价格
            const newSalePrice = destination.querySelector('.price-sale').textContent;
            const newComparePrice = destination.querySelector('.cap s').textContent;
            
            // 重新计算并更新优惠金额
            this.updateSaveAmount(destination, newSalePrice, newComparePrice);
          });
        },
        
        updatePriceElement(source, destination, selector) {
          const sourceElement = source.querySelector(selector);
          const destElement = destination.querySelector(selector);
          
          if (sourceElement && destElement) {
            // 只同步文本内容和必要的属性
            destElement.textContent = sourceElement.textContent;
            
            // 同步重要属性
            const attributesToSync = ['data-price', 'data-variant', 'aria-label', 'class', 'style'];
            attributesToSync.forEach(attr => {
              if (sourceElement.hasAttribute(attr)) {
                destElement.setAttribute(attr, sourceElement.getAttribute(attr));
              }
            });
          }
        },
        
        updateSaveAmount(destination, salePriceText, comparePriceText) {
          // 提取价格数值
          const salePrice = this.extractPrice(salePriceText);
          const comparePrice = this.extractPrice(comparePriceText);
          
          // 计算优惠金额
          const saveAmount = comparePrice - salePrice;
          
          // 查找所有需要显示优惠金额的元素
          const saveElements = destination.querySelectorAll('[data-save-amount], .save-amount, .show_save_container');
          
          if (saveElements.length > 0 && saveAmount > 0) {
            // 格式化优惠金额
            const formattedSaveAmount = this.formatCurrency(saveAmount);
            
            // 更新所有优惠金额显示元素
            saveElements.forEach(element => {
              // 根据元素类型决定如何更新
              if (element.classList.contains('show_save_container')) {
                element.textContent = `Save ${formattedSaveAmount}`;
              } else if (element.hasAttribute('data-save-amount')) {
                element.textContent = formattedSaveAmount;
                element.setAttribute('data-save-amount', saveAmount);
              } else {
                element.textContent = formattedSaveAmount;
              }
            });
          }
        },
        
        extractPrice(priceText) {
          // 从价格文本中提取数值（移除货币符号等）
          return parseFloat(priceText.replace(/[^\d.-]/g, ''));
        },
        
        formatCurrency(amount) {
          // 格式化货币显示
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
          }).format(amount);
        },
        
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        
        changeOptionSticky(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          event.target.selectedOptions[0].setAttribute('selected', 'selected');
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              inputId: inputId,
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}